export const ECHO_CONTEXT = "echo";

export const ECHO_URL = "https://echo.walletconnect.com";
